import '../shared/info-icon-popup/info-icon-popup.css';

import React, { useRef, useState } from 'react';

import Popup from '../shared/popup';
import PropTypes from 'prop-types';

const InfoPop = ({ popupText, children }) => {
	const [showInfo, setShowInfo] = useState({
		visible: false,
		ref: null,
		current: null
	});

	const infoRef = useRef(null);

	return (
		<>
			<div
				onClick={() =>
					setShowInfo({
						visible: true,
						ref: infoRef,
						content: popupText
					})
				}
				onMouseLeave={(e) => setShowInfo({ visible: false })}
				ref={infoRef}
			>
				{children}
			</div>
			<Popup
				showTelephonePopover={showInfo.visible}
				target={showInfo.ref || {}}
				placement="top-end"
			>
				<div onMouseLeave={(_) => setShowInfo({ visible: false })}>
					<div
						className="p-4 bg-white info-icon-popup col-12 col-md-3"
						style={{ maxWidth: '350px' }}
					>
						<span>{showInfo.content}</span>
					</div>
				</div>
			</Popup>
		</>
	);
};

InfoPop.propTypes = {
	popupText: PropTypes.string.isRequired
};

export default InfoPop;

